import React, { useState } from 'react';
import '../App.css'; // Ensure the path is correct

const Form = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        contact: '',
        linkedin: '', // Added LinkedIn field
        message: '',
    });
    const [responseMessage, setResponseMessage] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = ({ target: { name, value } }) => {
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.name || !formData.email || !formData.contact || !formData.linkedin || !formData.message) {
            setResponseMessage("All fields are required.");
            setIsSuccess(false);
            return;
        }

        setIsSubmitting(true);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/submit-form`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });

            const data = await response.json();

            if (response.ok) {
                setResponseMessage(data.message || 'Form submitted successfully!');
                setIsSuccess(true);
                setFormData({ name: '', email: '', contact: '', linkedin: '', message: '' });
            } else {
                throw new Error(data.message || 'Unexpected error occurred.');
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            setResponseMessage('Error submitting form. Please try again later.');
            setIsSuccess(false);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="form-container">
            <h2>🙌 Apply Now</h2>
            <form onSubmit={handleSubmit}>
                <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                />
                <input
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                />
                <input
                    type="text"
                    name="contact"
                    placeholder="Your Contact Number"
                    value={formData.contact}
                    onChange={handleChange}
                    required
                />
                <input
                    type="url"
                    name="linkedin"
                    placeholder="Your LinkedIn Profile URL"
                    value={formData.linkedin}
                    onChange={handleChange}
                    required
                />
                <textarea
                    name="message"
                    rows="5"
                    placeholder="Your Expertise and Experience"
                    value={formData.message}
                    onChange={handleChange}
                    required
                ></textarea>
                <button type="submit" disabled={isSubmitting}>
                    {isSubmitting ? 'Submitting...' : 'Submit'}
                </button>
            </form>
            {responseMessage && (
                <p
                    style={{
                        color: isSuccess ? 'green' : 'red',
                        marginTop: '10px',
                        fontWeight: 'bold',
                    }}
                >
                    {responseMessage}
                </p>
            )}
        </div>
    );
};

export default Form;
